import { render } from "./CadastroMoedasView.vue?vue&type=template&id=f76428a2"
import script from "./CadastroMoedasView.vue?vue&type=script&lang=js"
export * from "./CadastroMoedasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__